export interface Market {
  displayName: string;
  tags: string[];
  sectors: Sector[];
}

export interface Sector {
  displayName: string;
  tagId: string;
  childSectors: SubSector[];
}

export interface SubSector {
  displayName: string;
  tagId: string;
}

export enum MarketRegion {
  NA = 'na',
  EU = 'eu',
}

export enum MarketType {
  BONDS = 'bonds',
  LOANS = 'loans',
  SPECIAL_SITUATIONS = 'special situations',
  STRUCTURED_FINANCE = 'structured finance',
}

export interface MarketStats {
  region: MarketRegion;
  sections: any[];
  type: MarketType;
}

export interface MarketAggregated {
  [MarketRegion.NA]: MarketStats;
  [MarketRegion.EU]: MarketStats;
}
